import React from 'react';
import { Box } from '@mui/material';
import TitlePage from '../components/TitlePage';
import CTASection from '../components/CTASection';
import CharteAirMetrologie from '../components/CharteAirMetrologie';
import headerImage from '../assets/images/about/5.jpg';

const PolitiqueQualiteAirMetrologie = () => {
  return (
    <Box>
      <TitlePage 
        title="Politique Qualité Air Métrologie" 
        image={headerImage}
      />
      
      <CharteAirMetrologie />

      <CTASection />
    </Box>
  );
};

export default PolitiqueQualiteAirMetrologie;
